import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2659_2324",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2659_2324)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.028 17.2308C12.249 17.2308 12.4355 17.1544 12.5875 17.0017C12.7395 16.8491 12.8155 16.6623 12.8155 16.4413C12.8155 16.2201 12.7392 16.0336 12.5865 15.8818C12.4338 15.7298 12.2469 15.6538 12.0258 15.6538C11.8048 15.6538 11.6183 15.7301 11.4663 15.8828C11.3144 16.0354 11.2385 16.2223 11.2385 16.4435C11.2385 16.6645 11.3148 16.851 11.4675 17.003C11.6202 17.1548 11.807 17.2308 12.028 17.2308ZM11.5115 13.9192H12.477C12.5027 13.4846 12.5843 13.1313 12.722 12.8595C12.8598 12.5878 13.1435 12.2411 13.573 11.8193C14.0192 11.3731 14.3513 10.9734 14.5693 10.6203C14.7873 10.2671 14.8962 9.85825 14.8962 9.39375C14.8962 8.60558 14.6193 7.9775 14.0655 7.5095C13.5117 7.04167 12.8565 6.80775 12.1 6.80775C11.3808 6.80775 10.7703 7.00325 10.2683 7.39425C9.76642 7.78525 9.39883 8.23458 9.1655 8.74225L10.0845 9.123C10.2448 8.759 10.474 8.43725 10.772 8.15775C11.0702 7.87825 11.5 7.7385 12.0615 7.7385C12.7102 7.7385 13.1839 7.91633 13.4827 8.272C13.7814 8.62783 13.9307 9.01925 13.9307 9.44625C13.9307 9.79242 13.8372 10.1017 13.65 10.374C13.4628 10.6465 13.2193 10.9206 12.9193 11.1962C12.3398 11.7308 11.9602 12.1839 11.7808 12.5558C11.6013 12.9276 11.5115 13.3821 11.5115 13.9192ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
				fill: "#808282"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgHelpIcon);
export { ForwardRef as ReactComponent };
